import { FC } from 'react';
import { LinkList, RichText, Section, Stack } from '@belong/ui-components';
import { Layout as FormCard, Header } from '@belong/ui-components/components/layout/FormCard';
import { ISectionSimTypePicker } from './model';
import { BottomContent } from './styled';

interface IProps extends ISectionSimTypePicker {}

const SectionSimTypePicker: FC<IProps> = ({
  bottomContent,
  identifier,
  links,
  topContent,
  anchorName,
  sectionStyles
}) => {
  return (
    <Section {...sectionStyles} containsCard data-identifier={identifier} id={anchorName}>
      <FormCard>
        <Stack space={{ xs: 'large', md: 'xlarge' }}>
          <Header description={topContent.html} />
          <LinkList items={links} />
          <BottomContent>
            <RichText {...bottomContent} />
          </BottomContent>
        </Stack>
      </FormCard>
    </Section>
  );
};

export default SectionSimTypePicker;
